import { useState } from 'react'
import { BetHint, BetHintKind, BetKind, BettingValidator, Player } from '@ppwr/poker'
import { useStore } from '../../../../../../../models'
import { SuggestedBetRow } from './SuggestedBetRow'
import { DS } from '../../../../../../../design-system'

export interface SuggestedBetProps {
  onSelect: (amount: string) => void
}

export const SuggestedBet = ({ onSelect }: SuggestedBetProps) => {
  const {
    game: { biggestBet, callAmount, currentBlind, hints, myPlayer, minimumRaise, isThreeCard }
  } = useStore()

  const getHintsWithAllIn = (hints: BetHint[], myPlayer: Player) => {
    const allInAmount = myPlayer.chips

    const hintsLowerThanAllIn = hints
      .filter(
        (hint) =>
          BettingValidator.isValidBetForPlayer(
            {
              bigBlind: currentBlind.big,
              biggestBet: biggestBet || 0,
              playerAlreadyBet: myPlayer.bet,
              playerChips: myPlayer.chips,
              betAmount: hint.amount,
              callAmount,
              minimumRaise
            },
            BetKind.BET
          ).ok
      )
      .filter((hint) => hint.amount < allInAmount)

    if (isThreeCard) return hintsLowerThanAllIn

    const allInHint = new BetHint(allInAmount, BetHintKind.allin, 'All In')
    return [...hintsLowerThanAllIn, allInHint]
  }

  const [selectedHint, setSelectedHint] = useState<BetHint>()
  const allHints = myPlayer ? getHintsWithAllIn(hints, myPlayer) : hints
  const sortedHints = allHints.sort((a, b) => b.amount - a.amount)

  const handleSelectHint = (hint: BetHint) => {
    const newValue = selectedHint?.label !== hint.label ? hint : undefined
    setSelectedHint(newValue)
    onSelect(newValue ? newValue.amount.toString() : '')
  }

  return (
    <DS.Frame gap={'4'} flex={5}>
      {sortedHints.map((hint) => (
        <SuggestedBetRow
          key={hint.label}
          hint={hint}
          onSelect={handleSelectHint}
          selected={hint.label === selectedHint?.label}
        />
      ))}
    </DS.Frame>
  )
}
